import { render, staticRenderFns } from "./book-score-info.vue?vue&type=template&id=3086f3a1&scoped=true"
import script from "./book-score-info.vue?vue&type=script&lang=js"
export * from "./book-score-info.vue?vue&type=script&lang=js"
import style0 from "./book-score-info.vue?vue&type=style&index=0&id=3086f3a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3086f3a1",
  null
  
)

export default component.exports